import { usePollingQuery } from '../usePollingQuery'
import { fetchSystematicPaymentStatus } from '../../repository/mfExecution'
import { PaymentStatus } from '../../types/mf-execution.types'
import { useSearchParams } from 'react-router-dom'
import useTimer from '../useTimer'

export const useSystematicPaymentStatusQuery = ({ maxTimer }: { maxTimer: number }) => {
  const [searchParams] = useSearchParams()
  const sxpId = searchParams.get('sxpId')
  const { isExpired, timeLeft } = useTimer({ maxTimer })
  const {
    data: paymentStatus,
    isLoading,
    isFetching,
    isSuccess,
    isFetched,
    isError
  } = usePollingQuery({
    queryKey: ['systematicPaymentStatus', sxpId],
    queryFn: () => fetchSystematicPaymentStatus(sxpId as string),
    enabled: !!sxpId,
    shouldPoll: (data, error) => {
      // Only poll if status is AWAITING and we're not in error state
      const currentStatus = data?.status
      const isInErrorState = error !== null
      return currentStatus === PaymentStatus.AWAITING && !isInErrorState && !isExpired
    },
    pollInterval: 2000
  })

  return {
    paymentStatus,
    isError,
    isLoading,
    isFetching,
    isSuccess,
    isFetched,
    isExpired,
    timeLeft
  }
}
